import React, {
  useEffect,
  useState
} from 'react';

import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import TextField from '@mui/material/TextField';
import WhatsAppIcon
  from '@mui/icons-material/WhatsApp';
  import VerifiedIcon from '@mui/icons-material/Verified';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import axiosInstance from '../../api/axiosConfig';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DialogActions from '@mui/material/DialogActions';
const OurProducts = () => {

  const [products,
    setProducts] =
    useState([]);
  const [search, setSearch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [loading,
    setLoading] =
    useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const filteredProducts =
    products.filter(p =>
      p.productName
        ?.toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  const fetchProducts =
    async () => {

      try {

        const response =
          await axiosInstance.get(
            '/product/active'
          );

        setProducts(
          Array.isArray(
            response.data
          )
            ? response.data
            : []
        );

      } finally {

        setLoading(false);

      }
    };

  if (loading) {

    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 10
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const handleViewDetails = (product) => {
  setSelectedProduct(product);
  setOpenDialog(true);
};

  return (

    <Container
      maxWidth="xl"
      sx={{ py: 5 }}
    >

      <Box
        sx={{
          background: 'linear-gradient(135deg,#1976d2,#1565c0)',
          color: '#fff',
          borderRadius: 3,
          p: 5,
          mb: 4
        }}
      >
        <Typography variant="h3" fontWeight="bold">
          Industrial Safety Products
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Safety Shoes, Helmets, Gloves,
          Jackets, Harness & PPE Equipment
        </Typography>
      </Box>
      <TextField
        fullWidth
        placeholder="Search Products..."
        value={search}
        onChange={(e) =>
          setSearch(e.target.value)
        }
      />
      <Typography
  sx={{
    mt: 2,
    mb: 3,
    color: 'text.secondary'
  }}
>
  Showing {filteredProducts.length} Products
</Typography>
      <Grid
        container
        spacing={3}
      >

        {filteredProducts.map(
          product => {

            const whatsappNumber =
              product.whatsAppNumber ||
              '917979966901';

            const whatsappUrl =
              `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                `Hello, I am interested in ${product.productName}. Please share details and price.`
              )}`;

            return (

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={
                  product.productId
                }
              >

               <Card
  sx={{
    height: '100%',
    borderRadius: 3,
    position: 'relative',
    transition: '0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: 8
    }
  }}
>
<Chip
  icon={<VerifiedIcon />}
  label="Trusted Supplier"
  color="success"
  size="small"
  sx={{
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 1
  }}
/>
                  <CardMedia
                    component="img"
                    height="260"
                    sx={{
                      objectFit: 'contain',
                      backgroundColor: '#fafafa',
                      p: 2
                    }}
                    image={
                      product.imageUrl||
  '/no-image.svg'
                    }
                    alt={
                      product.productName
                    }
                  />

                  <CardContent>

                    <Typography
                      variant="h6"
                      fontWeight="bold"
                    >
                      {
                        product.productName
                      }
                    </Typography>
                    <Chip
  label={
    product.categoryName ||
    'Uncategorized'
  }
  color="primary"
  size="small"
  sx={{ mt: 1 }}
/>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mt: 1
                      }}
                    >
                      {
                        product.shortDescription
                      }
                    </Typography>

                    <Box sx={{ mt: 2 }}>
  <Typography
    variant="h5"
    color="primary"
    fontWeight="bold"
  >
    ₹ {product.price}
  </Typography>

  <Typography
    variant="caption"
    color="text.secondary"
  >
    Per Piece
  </Typography>
</Box>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1
                      }}
                    >
                      Brand:
                      {' '}
                      {
                        product.brand
                      }
                    </Typography>
                    <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    mt: 1
  }}
>
  <LocationOnIcon
    fontSize="small"
    color="action"
  />

  <Typography
    variant="body2"
    sx={{ ml: 0.5 }}
  >
    Delhi, India
  </Typography>
</Box>

<Typography
  variant="caption"
  color="success.main"
  sx={{
    display: 'block',
    mt: 1
  }}
>
  ✓ CIN Verified | Govt Registered
</Typography>

                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      startIcon={
                        <WhatsAppIcon />
                      }
                      href={
                        whatsappUrl
                      }
                      target="_blank"
                      sx={{
                        mt: 3
                      }}
                    >
                      WhatsApp Inquiry
                    </Button>
                    <Button
  fullWidth
  variant="outlined"
  sx={{ mt: 1 }}
  onClick={() => handleViewDetails(product)}
>
  View Details
</Button>

                  </CardContent>

                </Card>

              </Grid>

            );
            
          }
        )}

      </Grid>
      <Box
  sx={{
    mt: 8,
    p: 4,
    bgcolor: '#f5f5f5',
    borderRadius: 3
  }}
>
  <Typography variant="h5">
    About Our Safety Products
  </Typography>

  <Typography sx={{ mt: 2 }}>
    Kavya Institute provides
    industrial safety equipment,
    PPE kits, helmets, safety shoes,
    jackets, gloves and fire safety
    products for industries,
    construction projects and
    training institutions.
  </Typography>
</Box>

<Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  maxWidth="md"
  fullWidth
>
  {selectedProduct && (
    <>
     <DialogTitle
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}
>
  {selectedProduct.productName}

  <IconButton
    onClick={() => setOpenDialog(false)}
    size="small"
  >
    <CloseIcon />
  </IconButton>
</DialogTitle>

      <DialogContent>

        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img
            src={selectedProduct.imageUrl}
            alt={selectedProduct.productName}
            style={{
              maxWidth: '100%',
              maxHeight: '350px',
              objectFit: 'contain'
            }}
          />
        </Box>

        <Typography variant="h6" color="primary">
          ₹ {selectedProduct.price}
        </Typography>

        <Typography sx={{ mt: 2 }}>
  <strong>Category:</strong>{' '}
  {selectedProduct.categoryName || 'N/A'}
</Typography>

        <Typography sx={{ mt: 1 }}>
          <strong>Brand:</strong>{' '}
          {selectedProduct.brand}
        </Typography>

        <Typography sx={{ mt: 3 }}>
          {selectedProduct.description}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          color="success"
          startIcon={<WhatsAppIcon />}
          href={`https://wa.me/${
            selectedProduct.whatsAppNumber ||
            '917979966901'
          }?text=${encodeURIComponent(
            `Hello, I am interested in ${selectedProduct.productName}`
          )}`}
          target="_blank"
          sx={{ mt: 3 }}
        >
          WhatsApp Inquiry
        </Button>

      </DialogContent>
      <DialogActions>
  <Button
    onClick={() => setOpenDialog(false)}
    color="inherit"
  >
    Close
  </Button>
</DialogActions>
    </>
  )}
</Dialog>
<Box
  component="a"
  href="https://wa.me/917979966901"
  target="_blank"
  sx={{
    position: 'fixed',
    bottom: 25,
    right: 25,
    width: 60,
    height: 60,
    bgcolor: '#25D366',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 5,
    zIndex: 9999
  }}
>
  <WhatsAppIcon
    sx={{
      color: '#fff',
      fontSize: 35
    }}
  />
</Box>

    </Container>

  );
};

export default OurProducts;